/**
 * "Your tools" — every tool the person may use, grouped by Solution, one click
 * each (ADR-0070). The same tree, and the same rules, as the sidebar
 * (`app/solutionNav.tsx`): grants decide the agents, the role decides the
 * Developer+ and Administrator entries, the deployment decides the Solutions.
 */

import { Button, Group, Paper, Stack, Text, Title } from "@mantine/core";
import { Link as RouterLink } from "react-router-dom";
import { visibleSolutionGroups } from "@/app/solutionNav";

export function ToolsCard({
  agents,
  isDeveloperPlus,
  isAdmin,
  offered,
}: {
  agents: readonly string[];
  isDeveloperPlus: boolean;
  isAdmin: boolean;
  offered: readonly string[] | null | undefined;
}) {
  const groups = visibleSolutionGroups(agents, isDeveloperPlus, isAdmin, offered).map((g) => ({
    ...g,
    // A roadmap entry is not a tool yet.
    entries: g.entries.filter((e) => !e.soon),
  }));
  const shown = groups.filter((g) => g.entries.length > 0);

  return (
    <Paper withBorder radius="md" p="lg">
      <Title order={4} mb="sm">
        Your tools
      </Title>
      {shown.length === 0 ? (
        <Text size="sm" c="dimmed">
          No tools yet. Ask an Administrator for access to a Solution.
        </Text>
      ) : (
        <Stack gap="md">
          {shown.map((g) => (
            <div key={g.solution}>
              <Group gap={6} mb={6}>
                {g.icon}
                <Text size="sm" fw={600}>
                  {g.label}
                </Text>
              </Group>
              <Group gap={6}>
                {g.entries.map((e) => (
                  <Button
                    key={e.path}
                    component={RouterLink}
                    to={e.path}
                    variant="default"
                    size="compact-sm"
                    radius="xl"
                    fw={400}
                  >
                    {e.label}
                  </Button>
                ))}
              </Group>
            </div>
          ))}
        </Stack>
      )}
    </Paper>
  );
}
